@for (timelineItem of alarm.timeline; track timelineItem; let i = $index) {
  <div class="timeline">
    @if (timelineItem.action === 'email') {
      <div class="row">
        <div class="col-md-12">
          <span><i class="fa fa-envelope fa-fw"></i> <i class="fa fa-long-arrow-right"></i> {{timelineItem.value}}</span>
        </div>
      </div>
    }
    @if (timelineItem.action === 'state_change') {
      <div class="row">
        <div class="col-md-12">
          <span><i class="fa fa-level-down fa-fw"></i> State changed - "{{timelineItem.value}}"</span>
        </div>
      </div>
    }
    @if (timelineItem.action === 'notes') {
      <div class="row">
        <div class="col-md-12">
          <span><i class="fa fa-pencil-square-o  fa-fw"></i> notes added - "{{timelineItem.value}}"</span>
        </div>
      </div>
    }
  </div>
}